// extracted by mini-css-extract-plugin
export default {"link":"Button_link__Iz0W-"};